import { SalesOrderContractTaskSubscription } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1690. 受注案件契約タスク購読
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id/sales_order_contract_task_subscriptions
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const createSalesOrderContractTaskSubscription = (props: Props): Promise<SalesOrderContractTaskSubscription> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.task_id}/sales_order_contract_task_subscriptions`,
    props
  );
};

export const useCreateSalesOrderContractTaskSubscription = () => {
  return useMutation({
    mutationFn: createSalesOrderContractTaskSubscription
  });
};